import { differenceInCalendarDays, parseISO } from 'date-fns';

// Days-in-failed bucketing for the failed-salaries report. Framework-agnostic (no @/utils import)
// so it stays unit-testable in jest, mirroring paymentMethod.js.

export const FAILED_SALARY_BUCKET_LABELS = {
  UNKNOWN: '—',
  UNDER_TWO_WEEKS: 'Under 2 weeks',
  TWO_WEEKS: '2+ weeks',
  THREE_WEEKS: '3+ weeks',
};

const TWO_WEEKS_DAYS = 14;
const THREE_WEEKS_DAYS = 21;

// Whole calendar days a salary has been in the FAILED state (today − failed_at). Null when missing/invalid.
export const daysInFailed = (failedAt, now = new Date()) => {
  if (!failedAt) {
    return null;
  }
  const parsed = typeof failedAt === 'string' ? parseISO(failedAt) : failedAt;
  if (!(parsed instanceof Date) || Number.isNaN(parsed.getTime())) {
    return null;
  }
  return Math.max(0, differenceInCalendarDays(now, parsed));
};

// Escalation bucket label for a days-in-failed count.
export const bucketFor = days => {
  if (days == null) {
    return FAILED_SALARY_BUCKET_LABELS.UNKNOWN;
  }
  if (days >= THREE_WEEKS_DAYS) {
    return FAILED_SALARY_BUCKET_LABELS.THREE_WEEKS;
  }
  if (days >= TWO_WEEKS_DAYS) {
    return FAILED_SALARY_BUCKET_LABELS.TWO_WEEKS;
  }
  return FAILED_SALARY_BUCKET_LABELS.UNDER_TWO_WEEKS;
};
